document.addEventListener("DOMContentLoaded", () => {

  /* =========================
     Marquee Scroll Animation
  ========================= */
  const marqueeTrack = document.querySelector(
    ".how_to_use_section .loopMarque_track"
  );

  if (marqueeTrack && typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
    gsap.registerPlugin(ScrollTrigger);

    gsap.fromTo(
      marqueeTrack,
      {
        xPercent: 20
      },
      {
        xPercent: -30,
        ease: "none",
        scrollTrigger: {
          trigger: ".how_to_use_section",
          start: "top bottom",
          end: "bottom top",
          scrub: 2
        }
      }
    );
  }


  /* =========================
     TikTok Swiper
  ========================= */
  if (typeof Swiper !== "undefined") {
    const tiktokSwiper = document.querySelector(".tiktokSwiper");

    if (tiktokSwiper) {
      new Swiper(tiktokSwiper, {
        slidesPerView: 1.8,
        spaceBetween: 16,
        grabCursor: true,
        cssMode: true,
        speed: 1000,

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },

        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },

        breakpoints: {
         280: {
            slidesPerView: 1.5,
            spaceBetween: 12,
             centeredSlides: true,
             loop: true,
          },
          576: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          769: {
            slidesPerView: 3.2,
            spaceBetween: 20,
          },
          1025: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        },
      });
    }
  }


  /* =========================
     TikTok Video Play/Pause
  ========================= */
  const cards = document.querySelectorAll(".tiktok_card");

  cards.forEach((card) => {
    const video = card.querySelector("video");
    const playBtn = card.querySelector(".play_btn");

    if (!video || !playBtn) return;

    playBtn.addEventListener("click", (e) => {
      e.stopPropagation();

      if (video.paused) {

        document.querySelectorAll(".tiktok_card video").forEach((otherVideo) => {
          if (otherVideo !== video) {
            otherVideo.pause();

            const otherPlayBtn = otherVideo
              .closest(".tiktok_card")
              ?.querySelector(".play_btn");

            otherPlayBtn?.classList.remove("is-playing");
          }
        });

        video.play();
        playBtn.classList.add("is-playing");

      } else {
        video.pause();
        playBtn.classList.remove("is-playing");
      }
    });

    video.addEventListener("ended", () => {
      playBtn.classList.remove("is-playing");
    });
  });


  /* =========================
     Accordion
  ========================= */
  const accordionItems = document.querySelectorAll(".accordion_item");

  accordionItems.forEach((item) => {
    const header = item.querySelector(".accordion_heading");
    const content = item.querySelector(".accordion_content");

    if (!header || !content) return;

    header.addEventListener("click", () => {
      const isActive = item.classList.contains("active");

      accordionItems.forEach((otherItem) => {
        otherItem.classList.remove("active");

        const otherContent = otherItem.querySelector(".accordion_content");

        if (otherContent) {
          otherContent.style.maxHeight = null;
        }
      });

      if (!isActive) {
        item.classList.add("active");
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });

});